import { render, staticRenderFns } from "./ai-coding.vue?vue&type=template&id=a0cc0e72"
import script from "./ai-coding.vue?vue&type=script&lang=js"
export * from "./ai-coding.vue?vue&type=script&lang=js"
import style0 from "./ai-coding.vue?vue&type=style&index=0&id=a0cc0e72&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports